import { CreqStatus, HubFeature } from '@ats/api/cm';
import { LocDefs, LocMap, MapLocKeys } from '../../models';
import { SYSTEM_ENUM_ROOT } from '../shared-data';

const dpRoot = `${SYSTEM_ENUM_ROOT}|Credential Requirement Status`;

export type CPCreqStatusLocs =
	| 'CPCreqStatusEnumActive'
	| 'CPCreqStatusEnumInActive'
	| 'CPCreqStatusEnumInvalid';

export type SPCreqStatusLocs =
	| 'SPCreqStatusEnumActive'
	| 'SPCreqStatusEnumInActive'
	| 'SPCreqStatusEnumInvalid';

export const cpCreqStatusEnumLocs: LocDefs<CPCreqStatusLocs> = {
	CPCreqStatusEnumActive: {
		defaultValue: 'Active',
		displayPath: `${dpRoot}|${CreqStatus.Active}`,
		description: `System value for credential requirement status: '${CreqStatus.Active}'`,
		displayType: 'Content',
		feature: HubFeature.CredentialAchievements,
		legacyName: 'Credential.Achievements/System.Enum.CreqStatus.Active',
		portal: 'CP',
	},
	CPCreqStatusEnumInActive: {
		defaultValue: 'Inactive',
		displayPath: `${dpRoot}|${CreqStatus.InActive}`,
		description: `System value for credential requirement status: '${CreqStatus.InActive}'`,
		displayType: 'Content',
		feature: HubFeature.CredentialAchievements,
		legacyName: 'Credential.Achievements/System.Enum.CreqStatus.InActive',
		portal: 'CP',
	},
	CPCreqStatusEnumInvalid: {
		defaultValue: 'Invalid',
		displayPath: `${dpRoot}|${CreqStatus.Invalid}`,
		description: `System value for credential requirement status: '${CreqStatus.Invalid}'`,
		displayType: 'Content',
		feature: HubFeature.CredentialAchievements,
		legacyName: 'Credential.Achievements/System.Enum.CreqStatus.Invalid',
		portal: 'CP',
	},
};

export const spCreqStatusEnumLocs: LocDefs<SPCreqStatusLocs> = {
	SPCreqStatusEnumActive: {
		defaultValue: 'Active',
		displayPath: `${dpRoot}|${CreqStatus.Active}`,
		description: `System value for credential requirement status: '${CreqStatus.Active}'`,
		displayType: 'Content',
		feature: HubFeature.CredentialAchievements,
		legacyName: 'Credential.Achievements/System.Enum.CreqStatus.Active',
		portal: 'SP',
	},
	SPCreqStatusEnumInActive: {
		defaultValue: 'Inactive',
		displayPath: `${dpRoot}|${CreqStatus.InActive}`,
		description: `System value for credential requirement status: '${CreqStatus.InActive}'`,
		displayType: 'Content',
		feature: HubFeature.CredentialAchievements,
		legacyName: 'Credential.Achievements/System.Enum.CreqStatus.InActive',
		portal: 'SP',
	},
	SPCreqStatusEnumInvalid: {
		defaultValue: 'Invalid',
		displayPath: `${dpRoot}|${CreqStatus.Invalid}`,
		description: `System value for credential requirement status: '${CreqStatus.Invalid}'`,
		displayType: 'Content',
		feature: HubFeature.CredentialAchievements,
		legacyName: 'Credential.Achievements/System.Enum.CreqStatus.Invalid',
		portal: 'SP',
	},
};

export const CREQ_STATUS_ENUM_LOCS = MapLocKeys<CPCreqStatusLocs | SPCreqStatusLocs>({
	...cpCreqStatusEnumLocs,
	...spCreqStatusEnumLocs,
});

export type CPCreqStatusEnumLocType = LocMap<CPCreqStatusLocs>;
export type SPCreqStatusEnumLocType = LocMap<SPCreqStatusLocs>;

export const cpCreqStatusKeys: { [key in CreqStatus]: keyof CPCreqStatusEnumLocType } = {
	[CreqStatus.Active]: CREQ_STATUS_ENUM_LOCS.CPCreqStatusEnumActive,
	[CreqStatus.InActive]: CREQ_STATUS_ENUM_LOCS.CPCreqStatusEnumInActive,
	[CreqStatus.Invalid]: CREQ_STATUS_ENUM_LOCS.CPCreqStatusEnumInvalid,
};

export const spCreqStatusKeys: { [key in CreqStatus]: keyof SPCreqStatusEnumLocType } = {
	[CreqStatus.Active]: CREQ_STATUS_ENUM_LOCS.SPCreqStatusEnumActive,
	[CreqStatus.InActive]: CREQ_STATUS_ENUM_LOCS.SPCreqStatusEnumInActive,
	[CreqStatus.Invalid]: CREQ_STATUS_ENUM_LOCS.SPCreqStatusEnumInvalid,
};
